import { render, staticRenderFns } from "./AppBasePagination.vue?vue&type=template&id=5746fc4a&"
import script from "./AppBasePagination.vue?vue&type=script&lang=js&"
export * from "./AppBasePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports